module.exports = __webpack_public_path__ + "img/skype-logo.497c8135.svg";